import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = {
    [t('footer.services')]: [
      { key: 'footer.marketingStrategy', href: '#services' },
      { key: 'footer.metaAds', href: '#services' },
      { key: 'footer.webDesign', href: '/web-design' },
      { key: 'footer.automation', href: '#services' },
      { key: 'footer.aiSolutions', href: '#services' },
    ],
    [t('footer.products')]: [
      { key: 'footer.sellMoreWorkshop', href: '/sell-more-workshop' },
      { key: 'footer.prompts', href: '/advertising-prompts' },
      { key: 'footer.phoenixLite', href: '/phoenix-lite-mentoring' },
      { key: 'footer.trafficPro', href: '/traffic-pro' },
      { key: 'footer.trafficMaster', href: '/traffic-master' },
      { key: 'footer.webDesignPlans', href: '/web-design' },
    ],
  };

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-white">
                Santi<span className="text-primary-500">Ospina</span>
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-sm mb-6">
              {t('footer.tagline')}
            </p>
            <div className="flex items-center gap-4">
              {[
                { icon: 'ri-facebook-line', href: 'https://www.facebook.com/profile.php?id=61555791153825' },
                { icon: 'ri-instagram-line', href: 'https://instagram.com/santi_ospina_marketer?igshid=OGQ5ZDc2ODk2ZA==' },
                { icon: 'ri-linkedin-line', href: 'https://www.linkedin.com/in/santiago-ospina-piedrahita-810b56330/' },
                { icon: 'ri-whatsapp-line', href: 'https://wa.link/em25v1' },
                { icon: 'ri-tiktok-line', href: 'https://www.tiktok.com/@santi_ospinamarketer?_t=8hnEXdLSzoc&_r=1' },
                { icon: 'ri-youtube-line', href: 'https://youtube.com/@santiospinamarketer1462?si=OInpX7hhAaxWTmm2' },
              ].map(({ icon, href }) => (
                <a
                  key={icon}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-300 hover:text-primary-500 hover:border-primary-500 transition-all duration-300"
                  aria-label={icon.replace('ri-', '').replace('-line', '')}
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-sm font-semibold uppercase tracking-widest text-foreground-400 mb-5">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.key}>
                    <Link
                      to={link.href}
                      className="text-foreground-300 text-sm hover:text-primary-500 transition-colors duration-200"
                    >
                      {t(link.key)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} Santi Ospina Marketer. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-500 text-xs hover:text-primary-500 transition-colors">{t('footer.privacy')}</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-primary-500 transition-colors">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}